import Vue from "vue";
import VueAxios from "vue-axios";

import axios from "axios";

import config from "@/config";

axios.defaults.baseURL = `${config.apiURL}`;

if (process.env.NODE_ENV === "development") {
  axios.interceptors.request.use(request => {
    // eslint-disable-next-line no-console
    console.log("Starting request", request);
    return request;
  });

  axios.interceptors.response.use(response => {
    // eslint-disable-next-line no-console
    console.log("Got response", response);
    return response;
  });
}

Vue.use(VueAxios, axios);
